import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import GetFreeEstimateButton from './GetFreeEstimateButton';

const {FiFilter}=FiIcons;

const Portfolio=()=> {
  const [activeFilter,setActiveFilter]=useState('All');

  const filters=['All','Interior','Exterior','Power Wash'];

  const projects=[ 
    {
      id: 1,
      title: 'Modern Living Room Makeover',
      category: 'Interior',
      description: 'Complete color transformation with accent walls',
      image: 'https://images.unsplash.com/photo-1598928636135-d146006ff4be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      before: 'Outdated beige walls',
      after: 'Fresh modern colors with feature wall'
    },
    {
      id: 2,
      title: 'Victorian Home Exterior',
      category: 'Exterior',
      description: 'Historic home restoration with period-appropriate colors',
      image: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      before: 'Peeling paint and faded colors',
      after: 'Beautiful restored Victorian charm'
    },
    {
      id: 3,
      title: 'Master Bedroom Suite',
      category: 'Interior',
      description: 'Calming bedroom retreat with custom color scheme',
      image: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      before: 'Plain white walls',
      after: 'Sophisticated and serene atmosphere'
    },
    {
      id: 4,
      title: 'Professional Deck Power Washing',
      category: 'Power Wash',
      description: 'Complete deck power washing and restoration service',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752955378783-blob',
      before: 'Weathered and dirty deck boards',
      after: 'Clean,restored deck ready for staining'
    },
    {
      id: 5,
      title: 'Contemporary Kitchen Cabinet Transformation',
      category: 'Interior',
      description: 'Kitchen cabinet painting and wall refresh',
      image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      before: 'Outdated oak cabinets',
      after: 'Modern white kitchen transformation'
    },
    {
      id: 6,
      title: 'Driveway Power Washing',
      category: 'Power Wash',
      description: 'Complete driveway cleaning and restoration',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752976526848-blob',
      before: 'Stained and dirty concrete',
      after: 'Clean,like-new appearance'
    } 
  ];

  const filteredProjects=activeFilter==='All' ? projects : projects.filter(project=> project.category===activeFilter);

  return ( 
    <section id="portfolio" className="py-20 bg-gray-50"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        {/* Filter Buttons */} 
        <motion.div 
          initial={{opacity: 0,y: 20}} 
          whileInView={{opacity: 1,y: 0}} 
          transition={{duration: 0.6,delay: 0.2}} 
          viewport={{once: true}} 
          className="flex justify-center mb-12" 
        > 
          <div className="bg-white rounded-lg p-2 shadow-lg border border-gray-200"> 
            <div className="flex space-x-2"> 
              {filters.map((filter)=> ( 
                <button 
                  key={filter} 
                  onClick={()=> setActiveFilter(filter)} 
                  className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${activeFilter===filter ? 'bg-blue-600 text-white shadow-md' : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'}`} 
                > 
                  {filter} 
                </button> 
              ))} 
            </div> 
          </div> 
        </motion.div> 

        {/* Portfolio Grid */} 
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"> 
          <AnimatePresence> 
            {filteredProjects.map((project,index)=> ( 
              <motion.div 
                key={project.id} 
                layout 
                initial={{opacity: 0,scale: 0.8}} 
                animate={{opacity: 1,scale: 1}} 
                exit={{opacity: 0,scale: 0.8}} 
                transition={{duration: 0.6,delay: index * 0.1}} 
                className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" 
              > 
                <div className="relative overflow-hidden"> 
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" 
                  /> 
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div> 
                  {/* Category Badge */} 
                  <div className="absolute top-4 left-4"> 
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium"> 
                      {project.category} 
                    </span> 
                  </div> 
                </div> 
                <div className="p-6"> 
                  <h3 className="text-xl font-bold text-gray-900 mb-2"> 
                    {project.title} 
                  </h3> 
                  <p className="text-gray-600 mb-4"> 
                    {project.description} 
                  </p> 
                  <div className="space-y-2 text-sm"> 
                    <div className="flex justify-between"> 
                      <span className="text-gray-500">Before:</span> 
                      <span className="text-gray-700">{project.before}</span> 
                    </div> 
                    <div className="flex justify-between"> 
                      <span className="text-gray-500">After:</span> 
                      <span className="text-blue-600 font-medium">{project.after}</span> 
                    </div> 
                  </div> 
                </div> 
              </motion.div> 
            ))} 
          </AnimatePresence> 
        </motion.div> 

        {/* CTA Section */} 
        <motion.div 
          initial={{opacity: 0,y: 20}} 
          whileInView={{opacity: 1,y: 0}} 
          transition={{duration: 0.8}} 
          viewport={{once: true}} 
          className="text-center mt-16" 
        > 
          <div className="bg-blue-600 text-white rounded-2xl p-12"> 
            <h3 className="text-2xl lg:text-3xl font-bold mb-4"> 
              Ready to Transform Your Space? 
            </h3> 
            <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto"> 
              Let's discuss your project and create something beautiful together. Every great transformation starts with a conversation. 
            </p> 
            
            <GetFreeEstimateButton 
              variant="secondary" 
              size="large"
            >
              Start Your Project Today
            </GetFreeEstimateButton>
          </div> 
        </motion.div> 
      </div> 
    </section> 
  );
};

export default Portfolio;